import React from "react";

interface Props {
  size?: number;
  color?: string;
  className?: string;
}

export const WhatsappIcon: React.FC<Props> = ({
  size = 24,
  color = "#25D366",
  className = "",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M20.52 3.48A11.866 11.866 0 0012 0C5.373 0 0 5.373 0 12a11.95 11.95 0 001.684 6.024L0 24l6.22-1.623A11.91 11.91 0 0012 24c6.627 0 12-5.373 12-12 0-3.203-1.246-6.216-3.48-8.52zM12 21.5a9.463 9.463 0 01-4.785-1.356l-.342-.21-3.686.963.985-3.598-.22-.37A9.472 9.472 0 012.5 12c0-5.24 4.26-9.5 9.5-9.5 2.54 0 4.914.991 6.7 2.778A9.44 9.44 0 0121.5 12c0 5.24-4.26 9.5-9.5 9.5zm5.213-7.305c-.286-.143-1.693-.835-1.956-.93-.263-.093-.454-.142-.646.143s-.74.93-.91 1.123c-.166.193-.333.214-.62.071a7.34 7.34 0 01-2.15-1.317 8.185 8.185 0 01-1.518-1.88c-.158-.273-.017-.42.12-.56.123-.122.276-.32.414-.48.137-.158.183-.27.276-.45.093-.18.046-.337-.023-.48-.07-.143-.646-1.56-.886-2.14-.233-.557-.47-.48-.646-.488l-.552-.009a1.15 1.15 0 00-.845.4c-.287.33-1.1 1.08-1.1 2.63 0 1.55 1.127 3.05 1.285 3.26.16.21 2.22 3.39 5.383 4.75.75.323 1.334.516 1.79.66.75.23 1.435.197 1.976.12.602-.086 1.84-.75 2.1-1.476.26-.73.26-1.356.182-1.48-.075-.124-.276-.2-.56-.342z" />
  </svg>
);
